import styled from 'styled-components';

export const StyledFigurePreview = styled.div`
  width: 100vw;
  height: 100vh;
  background: ${({ theme }) => theme.background};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  model-viewer {
    width: 100vw;
    height: 100vh;

    button {
      background: ${({ theme }) => theme.baseYellow};
      border: solid 2px rgba(0, 0, 0, .16);
      position: absolute;
      top: 20px;
      right: 20px;
      text-transform: uppercase;
      font-family: "BebasNeue";
      font-size: 2rem;
      font-weight: 700;
      color: black;
      line-height: 2.5rem;
      padding-top: 6px;

      &:active {
        background: ${({ theme }) => theme.brightYellow};
        border-color: ${({ theme }) => theme.borderYellow};
      }
    }
  }
`;

